import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { keyBy } from '@mews/fp';

export const useGetAllResourcesQuery = () => {
    const enterpriseId = useCurrentEnterpriseId();

    return useRepositoryQuery(
        'resources',
        'getAll',
        {
            enterpriseId,
            extent: {
                resourceCategories: true,
                resourceCategoryAssignments: true,
                resourceFeatureAssignments: false,
                resourceFeatures: false,
                resources: true,
                slots: false,
            },
        },
        {
            select: (result) => ({
                resources: keyBy('id', result.resources),
                resourceCategories: keyBy('id', result.resourceCategories),
                resourceCategoryAssignments: keyBy('resourceId', result.resourceCategoryAssignments),
            }),
        }
    );
};
